import { useCallback } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { App } from 'antd';
import { useLazyGetDeliveryNoteQuery } from 'api/warehouse';

export const useLabelPrint = () => {
  const { message } = App.useApp();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const labelData = location.state?.labelData;

  const [getDeliveryNote, { isLoading: isDownloadingNote }] = useLazyGetDeliveryNoteQuery();

  const handlePrintDeliveryNote = useCallback(async () => {
    if (!id) return;

    try {
      message.loading({ content: 'Loading delivery note...', key: 'delivery-note' });

      const response: any = await getDeliveryNote(id).unwrap();

      if (response?.data?.files?.ATTACHMENTS) {
        const attachmentUrl = response.data.files.ATTACHMENTS;
        // Open in new tab instead of downloading
        window.open(attachmentUrl, '_blank');
        message.success({ content: 'Delivery note opened successfully', key: 'delivery-note' });
      } else {
        throw new Error('No delivery note found');
      }
    } catch (error: any) {
      message.error({
        content: error?.message || 'Failed to open delivery note',
        key: 'delivery-note',
      });
    }
  }, [id, getDeliveryNote, message]);

  const handlePrintLabel = useCallback(() => {
    if (!labelData?.files?.ATTACHMENTS) {
      message.error('No label file available');
      return;
    }

    try {
      // Open label in new tab for printing
      window.open(labelData.files.ATTACHMENTS, '_blank');
      message.success('Label opened for printing');

      // Navigate back to order details (same as Continue button in EXW flow)
      setTimeout(() => {
        navigate(`/warehouse/inbound/${id}`);
      }, 500);
    } catch (error: any) {
      message.error(error?.message || 'Failed to open label');
    }
  }, [labelData, message, id, navigate]);

  return {
    isLoading: false,
    labelData,
    isDownloadingNote,
    handlePrintDeliveryNote,
    handlePrintLabel,
  };
};
